export const PdpTechnicalSpecificationSectionUrlAnchor = "technical-specification";
